<div class="report-generator">
  <p-dialog [(visible)]="displayComponent"
    [header]="'GENERATE_REPORT.MODAL_TITLE' | translate"
    [draggable]="false"
    [closable]="true"
    [resizable]="false"
    [modal]="true" [closeOnEscape]="false"
    (onHide)="displayComponentChange.emit(false);">
    <div class="col-12">{{selectedDates}}</div>
    <div class="col-6">
      <p-fieldset [legend]="'GENERATE_REPORT.FS_FILTERS' |translate">
        <div class="col-12">
          <div class="col-4">{{'GENERATE_REPORT.DATE_FILTER_LABEL' |translate}}</div>
          <div class="col-8">
            <p-calendar #customPeriodCal [(ngModel)]="selectedDates" [dateFormat]="'dd/mm/yy'" [selectionMode]="'range'"
              [readonlyInput]="true" [showButtonBar]="true" (onSelect)="dateSelected()"
              [showIcon]="true" [minDate]="yearRange[0]" [maxDate]="yearRange[1]"></p-calendar>
          </div>
        </div>
        <div class="col-12">
          <div class="col-4">{{'GENERATE_REPORT.STATUS_FILTER_LABEL' |translate}}</div>
          <div class="col-8">
            <p-checkbox [(ngModel)]="validStatus" [binary]="true" [escape]="false" [pTooltip]="'GENERATE_REPORT.STATUS_FILTER_HELP' | translate" tooltipPosition="right" tooltipEvent="hover" [showDelay]="0" [hideDelay]="100"></p-checkbox>
          </div>
        </div>
        <div class="col-12">
          <div class="col-4">{{'GENERATE_REPORT.GROUP_FILTER_LABEL' |translate}}</div>
          <div class="col-8">
            <p-dropdown [filter]="true" [options]="groupList"
                        [(ngModel)]="selectedGroup" (onChange)="selectGroup()"
                        [style]="{'width':'100%'}">
            </p-dropdown>
          </div>
        </div>
        <div class="col-12" *ngIf="selectedGroup && selectedGroup != '_NA_' && userList && userList.length > 0">
          <div class="col-4">{{'GENERATE_REPORT.USER_FILTER_LABEL' |translate}}</div>
          <div class="col-8">
            <p-dropdown [filter]="true" [options]="userList"
                        [(ngModel)]="selectedUser"
                        [style]="{'width':'100%'}"></p-dropdown>
          </div>
        </div>
      </p-fieldset>
      <p-fieldset class="space-on-top" *ngIf="selectedCols && selectedCols.length >0" [legend]="'GENERATE_REPORT.FS_AGGREGATE' |translate">
        <div class="col-12">
          <div class="col-5">{{'GENERATE_REPORT.SUB_TOTAL_FIELD_LABEL' |translate}}</div>
          <div class="col-7">
            <p-dropdown [filter]="true" [options]="availableGroupFields" [optionLabel]="'label'"
                        [(ngModel)]="subTotalField" (onChange)="initSubTotalFields()"
                        [style]="{'width':'100%'}"></p-dropdown>
          </div>
        </div>
        <p-fieldset [legend]="'GENERATE_REPORT.TOTAL_FIELDS_LABEL' |translate" *ngIf="subTotalField && subTotalField.field !== '_NA_'">
          <div class="col-12">
            <div class="col-12 align-right" *ngIf="!showAddTotalField">
              <button pButton type="button" [label]="'COMMON.ADD' | translate"
                      [icon]="'fa fa-plus'" class="p-button-warning"
                      (click)="displayAddTotalField()"></button>
            </div>
            <div class="col-12" *ngIf="showAddTotalField">
<!--              <div class="col-12">
                <button pButton type="button" [label]="'LEFT.CONTAINER_COMPONENT.MANAGE_USER_RETURN_BUTTON_LABEL' | translate"
                        [icon]="'fa fa-arrow-circle-left'" class="p-button-info"
                        (click)="hideAddTotalField()"></button>
              </div>-->
              <div class="col-12">
                <div class="col-6">Valeur</div>
                <div class="col-6">
                  <p-dropdown [options]="availableTotalFields" [optionLabel]="'label'"
                              (onChange)="setNewTotalFieldName($event)"
                              [style]="{'width':'100%'}"></p-dropdown>
                </div>
              </div>
              <div class="col-12">
                <div class="col-6">Opération</div>
                <div class="col-6">
                  <p-dropdown [options]="operations"
                              (onChange)="setNewTotalFieldValue($event)"
                              [style]="{'width':'100%'}"></p-dropdown>
                </div>
              </div>
              <div class="col-12 align-right">
                <button pButton type="button"
                        [label]="'COMMON.SAVE' | translate"
                        [icon]="'fa fa-save'" class="p-button-warning"
                        (click)="saveTotalField()"
                        [disabled]="this.newTotalField.field === '' || this.newTotalField.operation === '' || this.newTotalField.operation === '_NA_'"></button>
              </div>
            </div>
            <div class="col-12">
              <p-table [value]="totalFields">
                <ng-template pTemplate="header">
                  <tr>
                    <th *ngFor="let col of cols" [width]="col.width">{{col.header | translate}}</th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-totalField let-rowIndex="rowIndex">
                  <tr>
                    <td >{{fieldLabels[totalField.field]}}</td>
                    <td >
                      <span *ngIf="totalField['operation'] === 'SUM'">Somme de valeurs</span>
                      <span *ngIf="totalField['operation'] !== 'SUM'">Nombre de valeurs</span>
                    </td>
                    <td >
                      <button pButton
                              type="button"
                              [icon]="'fa fa-trash-o'"
                              class="p-button-danger"
                              (click)="deleteTotalField(rowIndex)">
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>

        </p-fieldset>
      </p-fieldset>
      <div class="col-12" *ngIf="subTotalField && subTotalField.field !== '_NA_'">
        <div class="col-6">{{'GENERATE_REPORT.REPORT_TYPE_LABEL' |translate}}</div>
        <div class="col-6">
          <p-selectButton [options]="reportTypes" [(ngModel)]="selectedReportType"></p-selectButton>
        </div>
        <div class="col-12" *ngIf="selectedReportType === 'SYNTHETIC'">
          <div class="col-6"></div>
          <div class="col-6"><p-checkbox [(ngModel)]="includeDataSheet" [binary]="true"></p-checkbox>{{'GENERATE_REPORT.INCLUDE_DATA_SHEET_LABEL' |translate}}</div>
        </div>
      </div>
      <div class="col-12 align-right">
        <button pButton type="button"
                [label]="'GENERATE_REPORT.CREATE_REPORT_BTN' | translate"
                [icon]="'fa fa-save'" class="p-button-success"
                (click)="generateReport()"
                [disabled]="disableBtn()"></button>
      </div>
    </div>
    <div class="col-6">
      <p-fieldset [legend]="'GENERATE_REPORT.FS_COLUMNS' |translate">
        <p-listbox [options]="availableCols" [(ngModel)]="selectedCols"
                   (onChange)="initTotalFields()"
                   [metaKeySelection]="false"
                   [multiple]="true"
                   [checkbox]="false"
                   [filter]="true"
                   [dataKey]="'field'"
                   [optionLabel]="'label'">
        </p-listbox>
      </p-fieldset>
    </div>


  </p-dialog>
</div>
